"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_1 = require("react-router");
const core_1 = require("@material-ui/core");
const React = __importStar(require("react"));
const NavigateNext_1 = __importDefault(require("@material-ui/icons/NavigateNext"));
const react_router_2 = require("react-router");
const Link_1 = __importDefault(require("../Link"));
const matchRoute = (path, availableRoutes) => {
    return availableRoutes.length > 0 ? availableRoutes.some((r) => react_router_2.matchPath(path, r)) : true;
};
/**
 * The Breadcrumb group is rendered as part of AppLayout on top of main content area to provide page navigation information.
 */
const BreadcrumbGroup = ({ items, rootPath = 'Home', availableRoutes = [] }) => {
    if (!items) {
        return (React.createElement(react_router_1.Route, null, ({ location }) => {
            const pathnames = location.pathname.split('/').filter((e) => e);
            pathnames.unshift('/');
            return (React.createElement(core_1.Breadcrumbs, { separator: React.createElement(NavigateNext_1.default, { fontSize: "small" }), "aria-label": "Breadcrumb" }, pathnames.map((value, index) => {
                const last = index === pathnames.length - 1;
                const segment = pathnames.slice(0, index + 1);
                const to = segment.length === 1 ? '/' : `/${segment.slice(1).join('/')}`;
                const text = value
                    .split(' ')
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ');
                return last ? (React.createElement(core_1.Typography, { color: "inherit", key: to }, pathnames.length === 1 && value === '/' ? rootPath : text)) : matchRoute(to, availableRoutes) ? (React.createElement(Link_1.default, { key: to, href: to }, value === '/' ? rootPath : text)) : (React.createElement(core_1.Typography, { color: "inherit", key: to }, value === '/' ? rootPath : text));
            })));
        }));
    }
    return (React.createElement(react_router_1.Route, null,
        React.createElement(core_1.Breadcrumbs, { separator: React.createElement(NavigateNext_1.default, { fontSize: "small" }), "aria-label": "Breadcrumb" }, items.map((item, idx) => idx === items.length - 1 ? (React.createElement(core_1.Typography, { key: item.text, color: "textPrimary" }, item.text)) : (React.createElement(Link_1.default, { key: item.text, href: item.href }, item.text))))));
};
exports.default = BreadcrumbGroup;
//# sourceMappingURL=index.js.map